import AvisoPrivacidadPTMES from '../../resources/files/Aviso de Privacidad PTM ES.pdf'
import AvisoPrivacidadPTMEN from '../../resources/files/Aviso de Privacidad PTM EN.pdf'
import AvisoPrivacidadPTMT from '../../resources/files/Aviso Privacidad PTMT.pdf'
import AvisoPrivacidadMPV from '../../resources/files/Aviso de privacidad MPV.pdf'

import { COMPANY_PTM, COMPANY_MPV } from '../helpers/ResourcesHelper'
import { IsNullOrEmpty } from './StringHelper'

export const checkPrivacyNotice = (companyIdentifier, localStorage, activeprivacyNotice) => {
	if (activeprivacyNotice === null || activeprivacyNotice === '')
		return getNoticeOfPrivacy(companyIdentifier, localStorage)
	else
		return `${process.env.REACT_APP_SIP_URL_ADMINISTRATION}/Documents/PrivacyNotices/${activeprivacyNotice.token}.pdf`
}

export const checkPrivacyNoticePDF = (companyIdentifier, localStorage, activeprivacyNotice) => {
	if (activeprivacyNotice === null || activeprivacyNotice === '')
		return getNoticeOfPrivacy(companyIdentifier, localStorage)
	else
		return `${process.env.REACT_APP_SIP_URL_ADMINISTRATION}/Documents\\PrivacyNotices\\${activeprivacyNotice.token}.pdf`
}

export const getNoticeOfPrivacy = (selectedCompanyIdentifier, localStorage) => {
	switch (selectedCompanyIdentifier) {
		case COMPANY_PTM:
			return getNoticeOfPrivacyPTMByLanguaje(localStorage)
		case COMPANY_MPV:
			return AvisoPrivacidadMPV
		default:
			return AvisoPrivacidadPTMES
	}
}

export const getNoticeOfPrivacyPTMByLanguaje = (localStorage) => {
	let defaultLanguage = localStorage || localStorage.getItem('language')
	if (IsNullOrEmpty(defaultLanguage)) return AvisoPrivacidadPTMES
	if (defaultLanguage === 'es') return AvisoPrivacidadPTMES
	if (defaultLanguage === 'en') return AvisoPrivacidadPTMEN
	if (defaultLanguage === 'pt') return AvisoPrivacidadPTMES
	return AvisoPrivacidadPTMES
}

export const getNoticeOfPrivacyPTMTByLanguaje = (localStorage) => {
	let defaultLanguage = localStorage.getItem('language')
	if (IsNullOrEmpty(defaultLanguage)) return AvisoPrivacidadPTMT
	if (defaultLanguage === 'es') return AvisoPrivacidadPTMT
	return AvisoPrivacidadPTMES
}
